import YYSecurityImageUpload from './upload'

export default YYSecurityImageUpload